// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ItemInfo-Wrapper-lc6BOU"};